import { useState, useCallback } from 'react';
import ImageSourceModal from '../components/UI/ImageSourceModal/ImageSourceModal';
import { ImageSource } from '../components/UI/ImageSourceModal/types';

interface UseImageUploadOptions {
  onImageSelected: (url: string, source: ImageSource) => void;
}

export const useImageUpload = (options?: UseImageUploadOptions) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleImageSelected = useCallback(
    (url: string, source: ImageSource) => {
      options?.onImageSelected(url, source);
      setIsOpen(false);
    },
    [options]
  );

  const ImageUploadModal = (
    <ImageSourceModal
      show={isOpen}
      onHide={closeModal}
      onImageSelected={handleImageSelected}
    />
  );

  return {
    openModal,
    closeModal,
    ImageUploadModal,
    isOpen,
  };
};
